import { render } from "./MusicAudio.vue?vue&type=template&id=c4c15dfc&scoped=true"
import script from "./MusicAudio.vue?vue&type=script&lang=js"
export * from "./MusicAudio.vue?vue&type=script&lang=js"

import "./MusicAudio.vue?vue&type=style&index=0&id=c4c15dfc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c15dfc"]])

export default __exports__